export default {
  project_roboguard_title: {
    en: 'Roboguard',
    fr: 'Roboguard',
  },
  project_roboguard_description: {
    en: 'Robot safety. It is used to analyze the battery. Allows remote emergency stop activation.',
    fr: "Sécurité du robot. Il est utilisé pour analyser la batterie. Permet d'enclencherer l'arrêt d'urgence à distance.",
  },
  project_stackele_title: {
    en: 'Electrical Stack',
    fr: 'Batterie',
  },
  project_stackele_description: {
    en: 'Electrical components of the mobile base. It is used for power management and motor control.',
    fr: "Composantes électriques de la base mobile. Il est utilisé pour la gestion de l'alimentation et l'asservissement des moteurs.",
  },
  project_cartography_title: {
    en: '3D Mapping',
    fr: 'Cartographie 3D',
  },
  project_cartography_description: {
    en: "3D mapping and annotation of the robot's environment. It is used for autonomous navigation.",
    fr: "Cartographie 3D et annotation de l'environement du robot. Il est utilisé pour la navigation autonome.",
  },
  project_control_mobile_base_title: {
    en: 'Mobile Base Control',
    fr: 'Contrôle de la base mobile',
  },
  project_control_mobile_base_description: {
    en: 'Control of the mobile base. It is used for the movement control of the robot.',
    fr: 'Conversion des commandes de contrôle en mouvement. Perment de contrôler précisément le robot.',
  },
  project_arm_title: {
    en: 'Robotic Arm',
    fr: 'Bras robotique',
  },
  project_arm_description: {
    en: 'Robotic arm installed on the front of the robot. It is used for object manipulation and mannequin removal during search and rescue tasks.',
    fr: "Bras robotique installé sur l'avant du robot. Il est utilisé pour la manipulation d'objets et au retrait du mannequin lors des épreuves de recherche et sauvetage.",
  },
  project_gripper_title: {
    en: 'Gripper',
    fr: 'Pince robotique',
  },
  project_gripper_description: {
    en: 'Gripper installed on the robotic arm. It is used to grasp objects such as valves or door handles. It is installed at the end of the robotic arm.',
    fr: "Pince utilisée pour saisir des objets comme des valves ou des poignées de portes. Elle est installée à l'extrémité du bras robotique.",
  },
  project_winch_title: {
    en: 'Winch',
    fr: 'Treuil',
  },
  project_winch_description: {
    en: 'Winch installed on the front of the robot. In a rescue situation, it is used to pull the mannequin.',
    fr: 'Treuil avant du robot. En situation de sauvetage, il est utilisé pour tirer le mannequin.',
  },
  project_web_title: {
    en: 'Website',
    fr: 'Site web',
  },
  project_web_description: {
    en: 'The team website. It is used to share information about the club and projects.',
    fr: "Le site web de l'équipe. Il est utilisé pour partager les informations sur le club et les projets.",
  },
  project_topbox_title: {
    en: 'Top Box',
    fr: 'Boîte extérieure',
  },
  project_topbox_description: {
    fr: "Boîte extérieure du robot. Elle est utilisée pour protéger les composantes électroniques de capteurs d'environnement et de caméra.",
  },
  project_mobile_base_title: {
    en: 'Mobile Base',
    fr: 'Base mobile',
  },
  project_mobile_base_description: {
    en: 'Mobile base of the robot. It is used for the movement of the robot.',
    fr: 'Partie méchanique du robot. Elle est utilisée pour le déplacement du robot.',
  },
  project_radiation_title: {
    en: 'Radiation Detector',
    fr: 'Détecteur de radiation',
  },
  project_radiation_description: {
    en: 'Radiation detector installed on the robot. It is used in scenarios in a nuclear power plant.',
    fr: 'Détecteur de radiation installé sur le robot. Il est utilisé dans des scénarios dans une centrale nucléaire.',
  },
  project_crate_title: {
    en: 'Crate',
    fr: 'Boîte de transport',
  },
  project_crate_description: {
    en: 'Transport box of the robot with compartments for tools',
    fr: 'Boîte de transport du robot avec des compartiments pour les outils',
  },
  project_control_board_title: {
    en: 'Controle Board',
    fr: 'Carte de contrôle',
  },
  project_control_board_description: {
    en: 'Robot control board. It is used to control the winch, multicolor LEDs and front and rear lights.',
    fr: 'Carte de contrôle du robot. Elle est utilisée pour contrôler le treuil, les LEDs multicolore et les lumières avant et arrières.',
  },
  project_launch_handler_title: {
    en: 'Launch Handler',
    fr: 'Gestionnaire de lancement',
  },
  project_launch_handler_description: {
    en: 'Robot launch handler. It is used to control the robot during the competition allowing to launch configurations specific to each event.',
    fr: 'Gestionnaire de lancement du robot. Il est utilisé pour le contrôle du robot lors de la compétition permettant de lancer des configurations propres à chaque épreuve.',
  },
  project_gui_title: {
    en: 'GUI',
    fr: 'GUI',
  },
  project_gui_description: {
    en: 'Robot GUI. It is used for robot control and visualization of the robot and its environment state.',
    fr: "Interface graphique du robot. Elle est utilisée pour le contrôle du robot et de la visualisation de l'état de celui-ci et de son environnement.",
  },
  project_control_title: {
    en: 'Control System',
    fr: 'Système de contrôle',
  },
  project_control_description: {
    en: 'Robot control system. It is used for the integration of the different systems of the robot. It is used for remote control/gamepad control of the robot.',
    fr: 'Intégration des différents systèmes du robot. Il est utilisé pour le contrôle du robot par télécommande/manette.',
  },
  project_artificial_intelligence_title: {
    en: 'Artificial Intelligence',
    fr: 'Intelligence artificielle',
  },
  project_artificial_intelligence_description: {
    en: 'Artificial intelligence of the robot. It is used for autonomous navigation and object detection.',
    fr: "Intelligence artificielle du robot. Elle est utilisée pour la navigation autonome et la détection d'objets.",
  },
  project_support_title: {
    en: 'Stand',
    fr: 'Support',
  },
  project_support_description: {
    en: 'Robot stand. It is used to work on the robot and test motor controls.',
    fr: 'Support du robot. Il permet de travailler sur le robot et de tester les contrôles de moteur.',
  },
  project_communication_title: {
    en: 'Communication',
    fr: 'Communication',
  },
  project_communication_description: {
    en: 'Robot communication system. It is used for data transmission between the robot and the operator station.',
    fr: 'Système de communication du robot. Il est utilisé pour la transmission de données entre le robot et la station opérateur.',
  },
  project_telemetry_title: {
    en: 'Telemetry',
    fr: 'Télémétrie',
  },
  project_telemetry_description: {
    en: 'Robot telemetry system. It is used to monitor the robot state and its environment in real-time.',
    fr: "Système de télémétrie du robot. Il est utilisé pour surveiller l'état du robot et de son environnement en temps réel.",
  },
  project_battery_title: {
    en: 'Battery',
    fr: 'Batterie',
  },
  project_battery_description: {
    en: 'Robot battery system. It is used to power the robot and its components.',
    fr: 'Système de batterie du robot. Il est utilisé pour alimenter le robot et ses composantes.',
  },
};
